<template>
	<div>
		<notifications group="global" />
		<TopNav @toggle-menu="toggleMenu()" :menuOpen="menuOpen" home="dashboard"/>
		<div class="container">
			<div class="columns">
				<SideNav @toggle-menu="toggleMenu()" :menuOpen="menuOpen" />
				<slot />
			</div>
			<Footer/>
		</div>
	</div>
</template>

<script>
import TopNav from '../components/TopNav.vue'
import Footer from '../components/Footer.vue'
import SideNav from '../components/manager/SideNav.vue'

export default {
	components: {
		SideNav,
		TopNav,
		Footer
	},
	data() {
		return {
			menuOpen: false,
		}
	},
	methods: {
		toggleMenu() {
			this.menuOpen = !this.menuOpen
		},
	},
	created() {
		document.title = "Psychic Portal"
	}
}
</script>